<template>
    <div class="bg-white shadow-sm">
        <div class="container p-0 px-md-3 ">
            <!-- tab/desktop -->
            <nav class="d-none d-md-flex navbar navbar-expand-md root-navbar ml-0">
                <div class="w-100">
                    <div class="row align-items-center">
                        <div class="col-12 col-md-3 col-lg-2">
                            <a class="navbar-brand" :href="urlGenerator('/feed')"><img :src="urlGenerator(settings.company_logo)" alt="logo" class="logo"/></a>
                        </div>
                        <div class="col-8 col-md-9 col-lg-10">
                            <div class="row align-items-center">
                                <div class="col-12 col-md-8 col-lg-9">
<!--                                    <form class="form-inline w-100">-->
<!--                                        <div class="form-group has-search w-100 d-flex align-items-center">-->
<!--                                            <span class="fa fa-search form-control-feedback"></span>-->
<!--                                            <input type="search" class="form-control w-100" style="border-radius: 25px !important;" placeholder="Search">-->
<!--                                        </div>-->
<!--                                    </form>-->
                                    <global-search />
                                </div>
                                <div class="col-12 col-md-4 col-lg-3">
                                    <div class="d-flex justify-content-end align-items-center">
                                        <ul class="navbar-nav mr-2">
                                            <!-- notification list desktop -->
                                            <li class="nav-item dropdown position-relative">
                                                <a href="#"
                                                   id="notificationDropdown"
                                                   role="button"
                                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                   class="d-flex align-items-center nav-link">
                                                    <app-icon :name="'bell'"/>
                                                    <span class="badge badge-pill badge-danger px-2 py-1" style="position: absolute; top: 0; right: 0;" v-if="notifications?.total">{{ notifications?.total }}</span>
                                                    <!-- <span class="spinner-grow spinner-grow-sm" style="position: absolute; top: 0; right: 0;" v-if="notifications?.total"/> -->
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-center rounded-lg t p-0" onclick="event.stopPropagation()"
                                                     style="width: 320px; background-color: rgba(255, 255, 255, 0.9); backdrop-filter: blur(6px);" aria-labelledby="notificationDropdown">
                                                    <div style="height: 500px" class="d-flex flex-column">
                                                        <notification />
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>

<!--                                        <div class="d-block d-md-none d-lg-block mr-3">{{ user.full_name }}</div>-->
                                        <ul class="navbar-nav">
                                            <!--                    <li class="nav-item">-->
                                            <!--                        <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>-->
                                            <!--                    </li>-->
                                            <li class="nav-item dropdown">
                                                <a class="nav-link dropdown-toggle p-0" href="#" id="profileDropdown"
                                                   role="button"
                                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <img :src="user.img" width="40" height="40" class="rounded-circle">
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-right rounded-lg"
                                                     style="width: 220px; background-color: rgba(255, 255, 255, 0.9); backdrop-filter: blur(6px);" aria-labelledby="profileDropdown">
                                                    <a class="dropdown-item" :href="urlGenerator(ADMIN_DASHBOARD)" target="_blank">{{ $t('dashboard') }}</a>
                                                    <a class="dropdown-item" :href="urlGenerator('/profile/' + user.uuid)">{{ $t('profile') }}</a>
                                                    <a class="dropdown-item" :href="urlGenerator(LOGOUT)">{{ $t('Logout') }}</a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <!-- mobile view -->
            <div style="height: 60px; z-index: 100" class="d-flex justify-content-between align-items-stretch d-md-none">
                <div class="px-3">
                    <a class="navbar-brand" href="/"><img :src="urlGenerator(settings.company_logo)" alt="logo" class="logo"/></a>
                </div>
                <div>
                    <button @click="triggerNotification" class="menu-icon btn btn-square position-relative" :class="isNotificationExtended ? 'menu-icon--active': ''" type="button">
                        <app-icon name="bell" />
                        <span class="badge badge-pill badge-danger px-2 py-1" style="position: absolute; top: 5px; right: 5px;" v-if="notifications?.total">{{ notifications?.total }}</span>
                    </button>
                    <button @click="triggerMenu" class="menu-icon btn btn-square" :class="isMenuExtended ? 'menu-icon--active': ''" type="button">
                        <app-icon name="grid" />
                    </button>
                </div>
            </div>
            <Transition name="slide-fade" mode="out-in">

            <!-- menu panel for mobile -->
            <div class="mobile-menu" v-if="isMenuExtended">
                <div class="mobile-menu__panel d-flex flex-column p-3">
                    <global-search />
                    <div class="flex-fill">
                        <div class="d-flex flex-column">
                            <a v-for="(menu, index) in leftPanel" :key="`menu-item-index-${index}`"
                               class="btn btn-link text-left px-0" :class="isActive(menu.url)" :href="urlGenerator(menu.url)" :target="menu.target">
                                <div class="d-flex align-items-center gap-x-1">
                                    <app-icon :name="menu.icon" :size="16"/>
                                    <span class="text-capitalize">{{ menu.title }}</span>
                                </div>
                            </a>
                        </div>
                        <hr>
                        <div>
                            <a class="btn btn-block btn-danger rounded-pill" :href="urlGenerator(LOGOUT)">{{ $t('Logout') }}</a>
                        </div>
                    </div>
                </div>
            </div>
            </Transition>
            <Transition name="slide-fade" mode="out-in">
            <!-- notification panel for mobile -->
            <div class="mobile-menu" v-if="isNotificationExtended">
                <div class="mobile-menu__panel d-flex flex-column">
                    <notification />
                </div>
            </div>
            </Transition>

        </div>
    </div>
</template>

<script>
import Notification from "../views/Client/others/Notification/Notification";
import { mapGetters,mapMutations } from 'vuex'
import {urlGenerator} from "../../helpers/AxiosHelper";
import {ADMIN_DASHBOARD, LOGOUT} from "../../config/ApiUrl";
import GlobalSearch from "./GlobalSearch";
export default {
    components: { Notification, GlobalSearch },
    data() {
        return {
            urlGenerator,
            ADMIN_DASHBOARD,
            LOGOUT,
            isMenuExtended: false,
            isNotificationExtended: false,
            leftPanel: [
                {id: 1, title: 'news feed', icon: 'rss', url: '/feed', target: ''},
                {id: 2, title: 'profile', icon: 'user', url: '/profile/' + window.user.uuid, target: ''},
                {id: 2, title: 'admin', icon: 'settings', url: '/admin/dashboard', target: '_blank'},
            ]
        }
    },
    computed: {
        ...mapGetters({
            user: 'loggedInUser',
            settings: 'settings',
            notifications: 'getFormattedNotifications',
        }),
    },
    methods: {
        ...mapMutations(['SET_NOTIFICATIONS', 'SET_NOTIFICATIONS_EMPTY']),
        triggerMenu() {
            this.isNotificationExtended = false
            this.isMenuExtended = !this.isMenuExtended
        },
        triggerNotification() {
            this.isMenuExtended = false
            this.isNotificationExtended = !this.isNotificationExtended
        },
        isActive(url) {
            return window.location.pathname === url ? 'text-primary' : ''
        }
    },
    mounted() {
        this.$store.dispatch('ClientNotifications/getAll')
        if (window.broadcastDriver === 'pusher') {
            Echo.private(`user_notifications.${window.user?.id}`).listen(
                "NewNotification",
                ev => {
                    // console.log(ev.notifications)
                    this.SET_NOTIFICATIONS_EMPTY();
                    this.SET_NOTIFICATIONS(ev.notifications);
                    this.$toastr.s('', ev.message);
                    // this.$store.dispatch('getNotifications')
                }
            );
        }
    }
}
</script>

<style scoped lang="scss">
.root-navbar {
    height: 60px;
}

.logo {
    height: 48px;
    max-width: 180px;
    object-fit: contain;
}

.rounded-lg {
    border-radius: 15px !important;
    overflow: hidden;
}

.menu-icon {
    height: 100%;
    border-radius: 0 !important;
    &--active {
        background-color: #f6f6f6;
    }
}

.mobile-menu {
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-color: rgba(233, 233, 233, 0.9);
    backdrop-filter: blur(6px);
    transition: .1s ease-in-out;
    &--hide {
        transform: translateX(100%);
    }

    &--show {
        transform: translateX(0);
    }
    &__panel{
        overflow-y: scroll;
        height: calc(100% - 60px);
    }
}

.slide-fade-enter-active ,
.slide-fade-leave-active {
    transition: all .1s ease-in-out;
}
.slide-fade-enter, .slide-fade-leave-to{
    transform: translateX(100%);
}

</style>